var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("支付结果")]),_c('p',[_vm._v("订单 ID: "+_vm._s(_vm.orderId))]),_c('p',[_vm._v("订单金额: "+_vm._s(_vm.orderAmount))]),_c('p',[_vm._v("订单状态: "+_vm._s(_vm.orderStatus))])])
}
var staticRenderFns = []

export { render, staticRenderFns }